import React from 'react';
import ImagesIcon from '../../../assets/icons/Hotbar/ImagesIcon';
import VideosIcon from '../../../assets/icons/Hotbar/VideosIcon';
import AudiosIcon from '../../../assets/icons/Hotbar/AudiosIcon';
import DocumentsIcon from '../../../assets/icons/Hotbar/DocumentsIcon';
import WheelRound from '../../../assets/icons/WheelRound';
import CustomTabs from '../../../components/Tabs';

const TabNavigation = ({ selectedCategory, handleCategoryChange, storage }) => {
  return (
    <CustomTabs
      suffixStyle={{ paddingLeft: '20px', paddingRight: '20px' }}
      variant="standard"
      sx={{ pb: 2 }}
      categoriesWithIcons={[
        // {
        //   id: 'wheels',
        //   label: 'Wheels',
        //   value: 'Wheels',
        //   suffix: storage[3] || 0,
        //   space: storage[3] || 0,
        //   icon: (
        //     <WheelRound
        //       style={{
        //         marginRight: '-10px',
        //         marginTop: '8px',
        //         height: '30px',
        //         width: '30px',
        //       }}
        //     />
        //   ),
        // },
        {
          id: 'images',
          label: 'Images',
          value: 'Images',
          suffix: storage[2] || 0,
          space: storage[2] || 0,
          icon: (
            <ImagesIcon
              style={{ marginTop: '8px', marginRight: '-10px', height: '30px', width: '30px' }}
            />
          ),
        },
        {
          id: 'videos',
          label: 'Videos',
          value: 'Videos',
          suffix: storage[4] || 0,
          space: storage[4] || 0,
          icon: (
            <VideosIcon
              style={{ marginTop: '8px', marginRight: '-10px', height: '30px', width: '30px' }}
            />
          ),
        },
        {
          id: 'audios',
          label: 'Audios',
          value: 'Audios',
          suffix: storage[0] || 0,
          space: storage[0] || 0,
          icon: (
            <AudiosIcon
              style={{ marginTop: '8px', marginRight: '-10px', height: '30px', width: '30px' }}
            />
          ),
        },
        {
          id: 'documents',
          label: 'Documents',
          value: 'Documents',
          suffix: storage[1] || 0,
          space: storage[1] || 0,
          icon: (
            <DocumentsIcon
              style={{ marginTop: '8px', marginRight: '-5px', height: '30px', width: '30px' }}
            />
          ),
        },
      ]}
      selectedCategory={selectedCategory}
      onCategoryChange={handleCategoryChange}
    />
  );
};

export default TabNavigation;
